import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';

function withCollapsible(getState, actionCreator) {
  function withAction(WrappedComponent) {
    const wrappedComponentName =
            WrappedComponent.displayName || WrappedComponent.name || 'Component';

    class WithCollapsible extends Component {
            static displayName = `WithCollapsible(${wrappedComponentName})`;

            static propTypes = {
              selectedOption: PropTypes.shape({
                text: PropTypes.string,
                answer: PropTypes.string,
              }),
              data: PropTypes.any.isRequired,
              action: PropTypes.func.isRequired,
            };

            handleExpand = () => {
              this.props.action(this.props.data);
            };

            render() {
              const { data, selectedOption } = this.props;
              const isExpanded = isEqual(data, selectedOption);
              return (
                <WrappedComponent
                  data={data}
                  expanded={isExpanded}
                  onExpand={this.handleExpand}
                  {...this.props}
                    />
              );
            }
    }

    return connect(
      state => ({
        selectedOption: getState(state).selectedOption,
      }),
      dispatch => bindActionCreators({ action: actionCreator }, dispatch),
    )(WithCollapsible);
  }

  return withAction;
}

export default withCollapsible;
